import { calculatePrice, formatPrice, makePricingExplanationForEvaluation, makePricingExplanationForSubscription, makePricingExplanationForUninstalled } from '@atlassian/mpac-pricing-utils';
import { BodyNormal, BodySmall, Stripe } from '@atlassian/mpac-primitives';
import { DateUtils } from '@atlassian/mpac-utils';
import { List } from 'immutable';
import { usePricingPlan } from '../../../hooks';
import { getPricingPlanItems } from '../OneClickAppInstallDialog.util';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const isAppPrice = calculatePriceResult => !!calculatePriceResult && typeof calculatePriceResult.amount === 'number' && typeof calculatePriceResult.currencyCode === 'string';
export const PaidAppPricing = _ref => {
  let {
    appDetails,
    hostStatus,
    installedAppDetailsResult
  } = _ref;
  const {
    billingCurrency,
    hostLicense,
    upmLicensedHostUsers
  } = hostStatus.marketplaceStore.hostStatus;
  const {
    pricingPlanResult,
    pricingPlanPending,
    pricingPlanError
  } = usePricingPlan(appDetails.appId, billingCurrency);
  if (pricingPlanPending) {
    return /*#__PURE__*/_jsx(Stripe, {
      width: "5rem",
      height: "0.875rem",
      marginTop: "var(--ds-space-075, 6px)"
    });
  }
  if (pricingPlanError || !pricingPlanResult) {
    return /*#__PURE__*/_jsx(BodyNormal, {
      children: "Unknown Price"
    });
  }
  const pricingPlanItems = getPricingPlanItems(pricingPlanResult);
  const {
    subscriptionAnnual
  } = hostLicense;
  const pricingPlanItemsBySubscription = subscriptionAnnual ? List(pricingPlanItems.annual) : List(pricingPlanItems.monthly);
  const appPrice = calculatePrice(pricingPlanItemsBySubscription, upmLicensedHostUsers);
  if (!appPrice || !isAppPrice(appPrice.value)) {
    return /*#__PURE__*/_jsx(BodyNormal, {
      children: "Unknown Price"
    });
  }
  const {
    amount,
    currencyCode
  } = appPrice.value;
  const installedApp = installedAppDetailsResult === null || installedAppDetailsResult === void 0 ? void 0 : installedAppDetailsResult.marketplaceStore.installedAppDetails;
  const renderPricingExplaination = () => {
    const subscriptionType = subscriptionAnnual ? 'annual' : 'monthly';
    if (!installedApp || !(installedApp !== null && installedApp !== void 0 && installedApp.licenseActive)) {
      return makePricingExplanationForUninstalled(pricingPlanItemsBySubscription, upmLicensedHostUsers, appPrice.value, subscriptionType);
    }
    if (!installedApp.licenseExpiryDate || !DateUtils.isTodayOrFutureDate(new Date(installedApp.licenseExpiryDate))) {
      return makePricingExplanationForSubscription(pricingPlanItemsBySubscription, upmLicensedHostUsers, appPrice.value, subscriptionType);
    }
    return makePricingExplanationForEvaluation(pricingPlanItemsBySubscription, upmLicensedHostUsers, appPrice.value, subscriptionType, DateUtils.longDate(installedApp.licenseExpiryDate));
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(BodySmall, {
      children: renderPricingExplaination()
    }), /*#__PURE__*/_jsxs(BodyNormal, {
      children: [/*#__PURE__*/_jsx("strong", {
        children: formatPrice(installedApp !== null && installedApp !== void 0 && installedApp.paidLicenseActiveOnParent ? 0 : amount, currencyCode)
      }), ' ', "per ", subscriptionAnnual ? 'year' : 'month']
    })]
  });
};